import React from "react";
import IconButton from "@material-ui/core/IconButton";
import AppsIcon from "@material-ui/icons/Apps";
import Popover from "@material-ui/core/Popover";
import MenuOptions from "./MenuOptions";
import { useHistory } from "react-router-dom";

const AppSwitcher = () => {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdateFrameStatus = (url) => {
    history.push("/open?url=" + url);
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? "menuPopover" : undefined;
  return (
    <>
      <IconButton
        variant="contained"
        color="inherit"
        aria-label="menu"
        aria-describedby={id}
        onClick={handleClick}
      >
        <AppsIcon />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuOptions onUpdateFrameStatus={handleUpdateFrameStatus} />
      </Popover>
    </>
  );
};

export default AppSwitcher;
